import { ClassProvider } from '@angular/core';
import { WindowRef, BrowserWindowRef } from '../../../core';

export const browserWindowProvider: ClassProvider = {
  provide: WindowRef,
  useClass: BrowserWindowRef,
};
